import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pin-icon",
  "use": "pin-icon-usage",
  "viewBox": "0 0 40 47",
  "content": "<symbol viewBox=\"0 0 40 47\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"pin-icon\">\n  <path d=\"M34.0771 33.1538L20.001 46.8866L5.92441 33.1538C-1.8498 25.5693 -1.8498 13.2729 5.92441 5.6884C13.6986 -1.89613 26.3028 -1.89613 34.077 5.6884C41.8513 13.2729 41.8513 25.5693 34.0771 33.1538Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol